export const ROLES = {
    ADMIN: 'Admin',
    STUDENT: 'Student',
    TEACHER: 'Teacher',
    HR: 'HR',
    ACCOUNTANT: 'Accountant'
  };
  